import React, { Suspense } from 'react';
import { COMPONENT_MAP } from './componentMap';
import { ShouldRenderComponent } from '../components/ShouldRenderComponent';

export function getLayoutColClass(grid) {
  let column;

  switch (grid?.count) {
    case '2':
      column = 'grid-cols-2';
      break;
    case '3':
      column = 'grid-cols-3';
      break;
    case '4':
      column = 'grid-cols-4';
      break;
    case '5':
      column = 'grid-cols-5';
      break;
    case '6':
      column = 'grid-cols-6';
      break;
    case '7':
      column = 'grid-cols-7';
      break;
    case '8':
      column = 'grid-cols-8';
      break;
    case '9':
      column = 'grid-cols-9';
      break;
    case '10':
      column = 'grid-cols-10';
      break;
    case '11':
      column = 'grid-cols-11';
      break;
    case '12':
      column = 'grid-cols-12';
      break;
    default:
      column = 'grid-cols-1';
  }

  return column;
}

export function getSpanClass(span) {
  let column;

  switch (span) {
    case '2':
      column = 'col-span-2';
      break;
    case '3':
      column = 'col-span-3';
      break;
    case '4':
      column = 'col-span-4';
      break;
    case '5':
      column = 'col-span-5';
      break;
    case '6':
      column = 'col-span-6';
      break;
    case '7':
      column = 'col-span-7';
      break;
    case '8':
      column = 'col-span-8';
      break;
    case '9':
      column = 'col-span-9';
      break;
    case '10':
      column = 'col-span-10';
      break;
    case '11':
      column = 'col-span-11';
      break;
    case '12':
      column = 'col-span-12';
      break;
    default:
      column = 'col-span-1';
  }

  return column;
}
export function gatGapClass(data) {
  let gap;
  switch (data) {
    case 'no-gap':
      gap = null;
      break;
    default:
      gap = ' gap-1';
      break;
  }
  return gap;
}
export function getWidth(grid) {
  return grid;
}
export function getBgColor(bgColor) {
  return bgColor;
}

export function getHeight(height: string) {
  let heightClass = '';
  switch (height) {
    case 'h-full':
      heightClass = 'h-full';
      break;
  }
  return heightClass;
}

export function getFlexDirection(direction) {
  let flexDirection;

  switch (direction) {
    case 'row':
      flexDirection = 'flex-row';
      break;
    case 'column':
      flexDirection = 'flex-col';
      break;
    case 'row-reverse':
      flexDirection = 'flex-row-reverse';
      break;
    case 'column-reverse':
      flexDirection = 'flex-col-reverse';
      break;
    default:
      flexDirection = 'flex-row';
      break;
  }
  return flexDirection;
}

export function getJustifyContent(justifyContent) {
  if (justifyContent === 'start') {
    return 'justify-start';
  } else if (justifyContent === 'end') {
    return 'justify-end';
  } else if (justifyContent === 'center') {
    return 'justify-center';
  } else if (justifyContent === 'between') {
    return 'justify-between';
  } else if (justifyContent === 'around') {
    return 'justify-around';
  } else if (justifyContent === 'evenly') {
    return 'justify-evenly';
  }
}

export function getAlignItem(alignItem) {
  if (alignItem === 'start') {
    return 'items-start';
  } else if (alignItem === 'end') {
    return 'items-end';
  } else if (alignItem === 'center') {
    return 'items-center';
  } else if (alignItem === 'stretch') {
    return 'items-stretch';
  } else if (alignItem === 'baseline') {
    return 'items-baseline';
  }
}

export const renderComponents = (
  components,
  actions,
  entity,
  extensionEntity,
  params,
  query,
  fields,
  closePopup,
  filterParams,
  fragmentData,
) =>
  components.map((_c, index) => {
    const COMPONENT = COMPONENT_MAP[_c.type];
    if (!COMPONENT) return null;
    const rendered = (
      <Suspense key={`component_suspense_${index}`} fallback={<div>Loading...</div>}>
        <COMPONENT
          key={`component_map_${index}`}
          data={_c}
          actions={actions}
          entity={entity}
          extensionEntity={extensionEntity}
          params={params}
          query={query}
          fields={fields}
          closePopup={closePopup}
          filterParams={filterParams}
        />
      </Suspense>
    );
    if (_c.visibility?.conditions) {
      return (
        <ShouldRenderComponent
          key={`component_visibility_${index}`}
          visibilityCondition={_c.visibility.conditions}
          currentFragment={fragmentData}
        >
          {rendered}
        </ShouldRenderComponent>
      );
    }
    return rendered;
  });
